import {
	isCellSelected, 
	isColSelected, 
	isRowSelected, 
	selectRow, 
	selectColumn
} from "./operations/column_operations";
import {
	getColumnOperation, 
	getRowOperation,
	editMenu
} from "./toolbar/structure";
import { getMenuLabel, normalizeAction } from "./toolbar/helpers";
import { formatTemplate } from "./toolbar/buttons";

function setMenuLocaleLabels(options, action) {
	return options.map(o => {
		o.value = getMenuLabel(o.id, action);
		if (o.submenu) {
			const parent = (o.id === "format-row" || o.id === "format-column") ? "format" : "";
			o.submenu = setMenuLocaleLabels(o.submenu, parent);
		}
		return o;
	});
}

// Leaf items (no submenu): kept only if predicate(item) is truthy
// Parent items (has submenu): parent kept if predicate(item) and submenu filtered recursively and contains at least 1 item 
function filterNestedMenu(arr, predicate) {
	return arr.reduce((acc, item) => {
		if (predicate(item)) {
			if (item.submenu) {
				const submenu = filterNestedMenu(item.submenu, predicate);
				if (submenu.length) {
					const copy = webix.copy(item);
					copy.submenu = submenu;
					acc.push(copy);
				}
			} else {
				acc.push(item);
			}
		}
		return acc;
	}, []);
}


export function init(view){
	view.attachEvent("onComponentInit", () => {
		view.$$("context").attachTo(view._table.$view);
		view.$$("cells").attachEvent("onSelectChange", ()=> view.$$("context").hide());
	});

	let clipboard = [];
	if (view.config.clipboard !== false)
		clipboard = [
			{ id:"cut" },
			{ id:"copy" },
			{ id:"paste" },
			{ 
				id:"special-paste",
				submenu:[
					{ id: "paste-values"  },
					{ id: "paste-formulas" },
					{ id: "paste-styles" },
					{ id: "paste-conditions" },
					{ id: "paste-validation" },
					{ $template: "Separator" },
					{ id: "paste-transpose" }
				]
			}
		];

	const lists = {
		data: setMenuLocaleLabels(clipboard.concat(editMenu().filter(o => !!o.id.indexOf("sort-sheet")).sort((a,b) => a.menuOrder - b.menuOrder))),
		column: setMenuLocaleLabels(getColumnOperation(view)),
		row: setMenuLocaleLabels(getRowOperation(view))
	};

	if(!view.config.resizeCell){
		lists.column.splice(lists.column.findIndex(v => v.id == "resize-column"), 1);
		lists.row.splice(lists.row.findIndex(v => v.id == "resize-row"), 1);
	}

	const context = {
		view: "contextmenu",
		id: "context",
		padding:0,
		submenuConfig:{
			template: obj => obj.example ? formatTemplate(view, obj) : obj.value,
			padding:0,
			on:{
				onBeforeShow:function(){
					this.sizeToContent();
				}
			}
		},
		data:[],
		on:{
			onMenuItemClick(id) {
				const option = webix.copy(this.getMenuItem(id));
				normalizeAction(option);
				view.callEvent("onCommand", [option]);
			},
			onShow(){
				delete view._context;
			},
			onBeforeShow(pos) {
				view._context = true;
				webix.callEvent("onClick", []);

				const trg = view._table.locate(pos);
				if (!trg) return false;

				let mode = "";
				if (trg.header && trg.column !== "rowId"){
					if (!isColSelected(trg.column, view))
						selectColumn(trg.column, view);
					mode = "column";
				} else if (trg.row){
					if (trg.column === "rowId"){
						if (!isRowSelected(trg.row, view))
							selectRow(trg.row, view);
						mode = "row";
					} else {
						if (!isCellSelected(trg.row, trg.column, view))
							view._table.addSelectArea(trg, trg);
						mode = "data";
					}
				}

				if (mode){
					const area = view._table.getSelectArea();
					const sortDisabled = area.start.row === area.end.row;
					const options = sortDisabled ? filterNestedMenu(lists[mode], o => o.id !== "sort-range") : webix.copy(lists[mode]);
					const data = getMenuData(view, mode, options);
					if (data){
						this.clearAll();
						this.parse(data);
						this.sizeToContent();
						webix.html.preventEvent(pos);
						return true;
					}
				}
				return false;
			}
		}
	};

	view.callEvent("onViewInit", ["context", context]);
	const contextMenu = view.ui(context);

	view._destroy_with_me.push(contextMenu);
}

export function getMenuData(view, name, data){
	const ev = { area: name, data };
	if (view.callEvent("onContextMenuConfig", [ev]))
		return ev && ev.data;
	return null;
}
